module.exports = __webpack_public_path__ + "img/bremen.17743a7.webp";